import { useContext, useEffect } from "react";
import { useAuthUser, useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import { SocketContext } from "../App";
import { clearTabState } from "../utils/tabNavigation";
import useMcaNotification from "../hooks/useMcaNotification";
import useNotificationSocket from "../hooks/useNotificationSocket";
import { useClientVersionCheck } from "../hooks/useClientVersionCheck";

const SessionListener = () => {
  const auth = useAuthUser();
  const signOut = useSignOut();
  const navigate = useNavigate();
  const socket = useContext(SocketContext);

  useMcaNotification(socket);
  useNotificationSocket(socket);
  useClientVersionCheck({ notify: true });

  useEffect(() => {
    const user = auth();
    const userId = user?.id || user?._id;
    if (!socket || !userId) return;

    const join = () => socket.emit("joinUserRoom", { userId: String(userId) });
    if (socket.connected) join();
    socket.on("connect", join);

    const handleSessionInvalidated = () => {
      clearTabState(userId);
      signOut();
      navigate("/login");
    };

    socket.on("sessionInvalidated", handleSessionInvalidated);

    return () => {
      socket.off("connect", join);
      socket.off("sessionInvalidated", handleSessionInvalidated);
    };
  }, [socket, auth, signOut, navigate]);

  return null;
};

export default SessionListener;
